import React, { useState } from "react";
import {
    Table,
    Tag,
    Input,
    Select,
    Button,
    Modal,
    Form,
} from "antd";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";
import Layout from '../../Layout'
import { useTranslation } from "react-i18next";

import { Eye, Trash2, Pin } from "lucide-react";
import { Popconfirm, message } from "antd";
import { useNavigate } from "react-router-dom";

const { Option } = Select;

export default function AdsAccountManager() {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();

    const [data, setData] = useState([
        {
            key: 1,
            account: "Adsplus 5 - vienthammynkhothi",
            accountId: "act_4806/1121",
            platform: "Facebook",
            campaignType: "OUTCOME_ENGAGEMENT",
            campaignName: "[NHJCT-VIỆT KIỀU NAM-28.7-",
            adGroup: "Nhóm quảng cáo Lượt tương tác mới",
            adName: "Khách IT, cấy tóc phần tăng ver 2",
            spend: 1115160,
            date: "2025-11-10",
            idData: "fb_2025-11-10",
            status: "active",
            pinned: true,
        },
        {
            key: 2,
            account: "Adsplus 5 - vienthammynkhothi",
            accountId: "act_4806/1121",
            platform: "TikTok",
            campaignType: "OUTCOME_ENGAGEMENT",
            campaignName: "[NHJCT-VIỆT KIỀU NAM-28.7-",
            adGroup: "Nhóm quảng cáo Lượt tương tác mới",
            adName: "Khách IT, cấy tóc phần tăng ver 2",
            spend: 2450000,
            date: "2025-11-10",
            idData: "tt_2025-11-10",
            status: "active",
            pinned: false,
        },
        {
            key: 3,
            account: "Adpush 5 - reinharmyvinhhh",
            accountId: "act_4002085112",
            platform: "Facebook",
            campaignType: "-",
            campaignName: "-",
            adGroup: "-",
            adName: "-",
            spend: 18200000,
            date: "-",
            idData: "-",
            status: "pause",
            pinned: true,
        },
        {
            key: 4,
            account: "Adpush 5 - reinharmyvinhhh",
            accountId: "act_4002085112",
            platform: "Facebook",
            campaignType: "-",
            campaignName: "-",
            adGroup: "-",
            adName: "-",
            spend: 45800000,
            date: "-",
            idData: "-",
            status: "active",
            pinned: false,
        },
    ]);

    const sortedData = [...data].sort((a, b) =>
        a.pinned === b.pinned ? 0 : a.pinned ? -1 : 1
    );

    const navigate = useNavigate();

    const handleDelete = (record: any) => {
        setData((prev: any) =>
            prev.filter((item: any) => item.key !== record.key)
        );
        message.success(t("ads.delete_success"));
    };

    const handlePin = (record: any) => {
        setData((prev: any) =>
            prev.map((item: any) =>
                item.key === record.key
                    ? { ...item, pinned: !item.pinned }
                    : item
            )
        );
    };

    const columns = [
        {
            title: t("ads.col_account"),
            dataIndex: "account",
            width: 250,
            render: (_: any, record: any) => (
                <div>
                    <div className="font-medium">{record.account}</div>
                    <div className="text-xs text-gray-400">
                        {record.accountId}
                    </div>
                </div>
            ),
        },
        {
            title: t("ads.col_platform"),
            dataIndex: "platform",
            width: 120,
            render: (text: string) => (
                <div className="flex items-center gap-2">
                    <div className={`w-6 h-6 rounded-full flex items-center justify-center text-white text-xs
          ${text === "Facebook" ? "bg-blue-500" : "bg-black"}`}>
                        {text === "Facebook" ? "f" : "t"}
                    </div>
                    {text}
                </div>
            ),
        },
        {
            title: t("ads.col_campaign_type"),
            dataIndex: "campaignType",
            width: 180,
            render: (text: string) =>
                text !== "-" ? (
                    <span className="px-2 py-1 text-xs rounded-full bg-blue-50 text-blue-600">
                        {text}
                    </span>
                ) : (
                    "-"
                ),
        },
        {
            title: t("ads.col_campaign_name"),
            dataIndex: "campaignName",
            width: 220,
        },
        {
            title: t("ads.col_ad_group"),
            dataIndex: "adGroup",
            width: 220,
        },
        {
            title: t("ads.col_ad_name"),
            dataIndex: "adName",
            width: 220,
        },
        {
            title: t("ads.col_spend"),
            dataIndex: "spend",
            width: 140,
            render: (val: number) => (
                <span className="font-semibold">
                    {formatMoney(val)}
                </span>
            ),
        },
        {
            title: t("ads.col_date"),
            dataIndex: "date",
            width: 120,
        },
        {
            title: "ID Data",
            dataIndex: "idData",
            width: 150,
            render: (text: string) => (
                <span className="text-xs text-gray-400 bg-gray-100 px-2 py-1 rounded">
                    {text}
                </span>
            ),
        },
        {
            title: t("ads.col_status"),
            dataIndex: "status",
            width: 140,
            render: (status: string) =>
                status === "active" ? (
                    <span className="px-3 py-1 rounded-full bg-green-100 text-green-600 text-sm">
                        ● {t("ads.status_active")}
                    </span>
                ) : (
                    <span className="px-3 py-1 rounded-full bg-yellow-100 text-yellow-600 text-sm">
                        ● {t("ads.status_paused")}
                    </span>
                ),
        },
        {
            title: t("ads.col_actions"),
            width: 140,
            render: (_: any, record: any) => (
                <div className="flex items-center gap-3 text-gray-500">

                    {/* VIEW */}
                    <Eye
                        className="w-5 h-5 cursor-pointer hover:text-blue-500 transition"
                        onClick={() => navigate(`/advertise/detail`)}
                    />

                    {/* PIN */}
                    <Pin
                        className={`w-5 h-5 cursor-pointer transition ${record.pinned
                            ? "text-orange-500 rotate-45"
                            : "hover:text-orange-500"
                            }`}
                        onClick={() => handlePin(record)}
                    />

                    {/* DELETE */}
                    <Popconfirm
                        title={t("ads.delete_confirm_title")}
                        description={t("ads.delete_confirm_desc")}
                        okText={t("ads.delete")}
                        cancelText={t("ads.cancel")}
                        okButtonProps={{ danger: true }}
                        onConfirm={() => handleDelete(record)}
                    >
                        <Trash2 className="w-5 h-5 cursor-pointer hover:text-red-500 transition" />
                    </Popconfirm>
                </div>
            ),
        },
    ];

    const handleSubmit = (values: any) => {
        console.log("Form:", values);
        setOpen(false);
        form.resetFields();
    };

    const formatMoney = (num: number) =>
        num?.toLocaleString("vi-VN") + " " + t("ads.currency_suffix");

    return (
        <Layout>
            {/* HEADER */}
            <div className="flex flex-col md:flex-row justify-between gap-4 mb-4">
                <div>
                    <h2 className="text-xl font-semibold dark:text-white mb-2">
                        {t("ads.title")}
                    </h2>
                    <p className="text-gray-500 text-sm" dangerouslySetInnerHTML={{ __html: t("ads.total_accounts", { count: data.length }) }} />
                </div>

                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    className="rounded-lg"
                    onClick={() => setOpen(true)}
                >
                    {t("ads.add_account")}
                </Button>
            </div>

            {/* FILTER */}
            <div className="flex flex-col md:flex-row gap-3 mb-4">
                <Input
                    placeholder={t("ads.search_placeholder")}
                    prefix={<SearchOutlined />}
                />

                <Select defaultValue="all" className="w-full md:w-[180px]">
                    <Option value="all">{t("ads.all_platforms")}</Option>
                    <Option value="facebook">Facebook</Option>
                    <Option value="tiktok">TikTok</Option>
                </Select>

                <Select defaultValue="all" className="w-full md:w-[180px]">
                    <Option value="all">{t("ads.all_statuses")}</Option>
                    <Option value="active">{t("ads.status_active")}</Option>
                    <Option value="pause">{t("ads.status_paused")}</Option>
                </Select>
            </div>

            {/* TABLE */}
            <div className="overflow-x-auto">
                <Table
                    columns={columns}
                    dataSource={sortedData}
                    pagination={{ pageSize: 6 }}
                    scroll={{ x: "max-content" }}
                    className="custom-ant-table"
                />
            </div>

            {/* MODAL */}
            <Modal
                open={open}
                onCancel={() => setOpen(false)}
                footer={null}
                centered
                width={500}
                className="rounded-xl"
            >
                <h3 className="text-lg font-semibold mb-4 dark:text-white">
                    {t("ads.modal_title")}
                </h3>

                <Form layout="vertical" form={form} onFinish={handleSubmit}>
                    <Form.Item
                        label={t("ads.label_account_name")}
                        name="name"
                        rules={[{ required: true, message: t("ads.required_account_name") }]}
                    >
                        <Input placeholder={t("ads.placeholder_account_name")} />
                    </Form.Item>

                    <Form.Item
                        label={t("ads.label_platform")}
                        name="platform"
                        rules={[{ required: true, message: t("ads.required_platform") }]}
                    >
                        <Select placeholder={t("ads.placeholder_platform")}>
                            <Option value="facebook">Facebook</Option>
                            <Option value="tiktok">TikTok</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label={t("ads.label_account_id")}
                        name="accountId"
                        rules={[{ required: true, message: t("ads.required_account_id") }]}
                    >
                        <Input placeholder={t("ads.placeholder_account_id")} />
                    </Form.Item>

                    <Form.Item
                        label={t("ads.label_customer")}
                        name="customer"
                        rules={[{ required: true, message: t("ads.required_customer") }]}
                    >
                        <Select placeholder={t("ads.placeholder_customer")}>
                            <Option value="kh1">Khách hàng A</Option>
                            <Option value="kh2">Khách hàng B</Option>
                        </Select>
                    </Form.Item>

                    <div className="flex justify-end mt-4">
                        <Button
                            type="primary"
                            htmlType="submit"
                            className="rounded-lg px-6"
                        >
                            {t("ads.add_account")}
                        </Button>
                    </div>
                </Form>
            </Modal>
        </Layout>
    );
}